var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_71",
    "data-name": "Group 71",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58.15,
    height: 79.776,
    viewBox: "0 0 58.15 79.776",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_403",
    "data-name": "Rectangle 403",
    width: 58.15,
    height: 79.776,
    fill: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M3.544,53.7A24.56,24.56,0,0,1,.818,46.976a30.278,30.278,0,0,1-.818-7A28.144,28.144,0,0,1,8.54,19.4a27.925,27.925,0,0,1,20.535-8.588h2.817L25.078,4.089,29.167,0l13.9,13.9-13.9,13.81-4.089-4.089L31.8,16.9H29.075a22.079,22.079,0,0,0-16.263,6.769A22.3,22.3,0,0,0,6.086,39.978a22.959,22.959,0,0,0,.5,4.861,32.064,32.064,0,0,0,1.317,4.5Zm25.35,26.077-13.9-13.9,13.9-13.81,4,4-6.723,6.815h2.907a22.079,22.079,0,0,0,16.263-6.769A22.3,22.3,0,0,0,52.064,39.8a25.189,25.189,0,0,0-.456-4.861,20.061,20.061,0,0,0-1.452-4.5l4.451-4.361A27.561,27.561,0,0,1,57.289,32.8a28.825,28.825,0,0,1,.861,7,28.149,28.149,0,0,1-8.54,20.581,27.923,27.923,0,0,1-20.535,8.585H26.168l6.723,6.723Z",
    transform: "translate(0 0)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.2f834d33db91333bcc092f737e2d4bb6.svg";
export { ForwardRef as ReactComponent };